export const isLinkExternal = (href: string) => {
    const urlToCheck = new URL(href, window.location.href);

    return urlToCheck.origin !== window.location.origin;
};
